import { Alert, Snackbar } from '@mui/material'
import { FC } from 'react'

type CacheHasBeenResetToasterProps = {
  isOpen: boolean
  onClose: () => void
  autoHideDurationMs?: number
}

export const CacheHasBeenResetToaster: FC<CacheHasBeenResetToasterProps> = ({
  isOpen = false,
  onClose,
  autoHideDurationMs = 5000
}) => (
  <Snackbar
    open={isOpen}
    autoHideDuration={autoHideDurationMs}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    message='Cache has been reset!'
    color='success'
    onClose={onClose}
  >
    <Alert onClose={onClose} severity='success' variant='filled' sx={{ width: '100%' }}>
      Cache has been reset!
    </Alert>
  </Snackbar>
)
